export const HEADER_LANGUAGE_PICKER_MODAL_ID = 'header-language-picker';
